import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpService } from '../shared/services/http.service';
import { CustomValidators } from './CustomValidator';

@Component({
  selector: 'app-code-detail',
  templateUrl: './code-detail.component.html',
  styleUrls: ['./code-detail.component.scss'],
  standalone: false
})
export class CodeDetailComponent implements OnInit {

  @Input() code;

  @Output() close: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  usingStencil = ''

  submitted = false

  codeForm: UntypedFormGroup

  stencils = []
  serverError = ''

  constructor(private fb: UntypedFormBuilder, private httpService: HttpService) { }

  async ngOnInit() {

    const stencilsResponse: any = await this.httpService.getAsync('hcode/getStencils')
    if (stencilsResponse) {
      const data = [...stencilsResponse.data]
      this.stencils = data
    }


    this.createCodeForm()

    if( this.code && this.code.use_stencil_id ){
      const stencil = this.stencils.find( stencil => stencil.id == this.code.use_stencil_id )
      this.usingStencil = stencil.description
    }


  }

  onTemplateChange($event) {
    // $event is fired by the select box. get the selected label and set the description
    const stencil = this.stencils.find(stencil => stencil.id == $event.value)
    this.f.description.setValue(stencil.description)
  }

  get f() {
    return this.codeForm.controls
  }

  get otherStencils() {
    return this.stencils.filter(stencil => stencil.id != this.code.id)
  }

  ngOnChanges() {
    this.createCodeForm()
    this.rebuildForm()
  }

  convertDate(dateString) {
    if (!dateString) {
      return ''
    }

    var dateParts = dateString.split("-")

    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
  }

  rebuildForm() {
    if (!this.code) {
      return
    }
    this.codeForm.reset({
      code: this.code.code,
      description: this.code.description,
      active: this.code.active,
      expected_users: this.code.expected_users,
      expiry: this.convertDate(this.code.expiry),
      expected_completion: this.convertDate(this.code.expected_completion),
      use_stencil_id: this.code.use_stencil_id
    })

    this.submitted = false

  }

  onCancel() {
    this.close.emit(false)
  }

  async onSubmit() {

    const formModel = this.codeForm.getRawValue();
    this.submitted = true
    this.serverError = ''

    Object.keys(this.codeForm.controls).forEach(field => {
      const control = this.codeForm.get(field);
      if (control.invalid) {
        console.log(`${field} is invalid`);
      }
    });

    if (this.codeForm.invalid) {
      return
    }

    const save = {
      code: this.code && this.code.code,
      client_id: this.code.clientId,
      description: formModel.description,
      active: formModel.active,
      expiry: formModel.expiry,
      expected_users: formModel.expected_users,
      expected_completion: formModel.expected_completion,
      templateId: formModel.use_stencil_id,
      stencil: !!this.code.stencil
    }

    let result
    if (save.code) {
      result = await this.httpService.postAsync('hcode/updateCode', save)
    }
    if (!save.code) {
      result = await this.httpService.postAsync('hcode/newCode', save)
    }
    if (!result.success) {
      this.serverError = result.message
      return
    }


    this.close.emit(true)
  }


  createCodeForm() {

    const lockStencil = this.code.kind == 'EDUCATION' && !!this.code.code;

    this.codeForm = this.fb.group({
      code: this.code.code,
      description: [this.code.description, Validators.required],
      active: this.code.active,
      use_stencil_id: [{ value: this.code.use_stencil_id, disabled: lockStencil }, this.code.kind == 'EDUCATION' ? Validators.required : null],
      expected_users: [this.code.expected_users, this.code.stencil ? null : Validators.required],
      expected_completion: [this.convertDate(this.code.expected_completion), this.code.stencil ? null : Validators.required],
      expiry: [this.convertDate(this.code.expiry), CustomValidators.notGreaterThan(new Date(this.convertDate(this.code.contract_end)))]
    })
  }
}
